import ApplicationDetails from "./ApplicationDetails";

export default ApplicationDetails;
